import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    background: 'rgba(196, 196, 196, 0.2)',
    color: theme.palette.text.primary,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: theme.spacing(4),
    padding: '4px 0px',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
    },
    '& span': {
      color: theme.palette.text.primary,
    },
    '& hr': {
      color: 'rgba(131, 111, 80, 0.5)',
    },
  },
}))

export default useStyles
